import { useQuery } from "@tanstack/react-query";
import type { UseQueryOptions, UseQueryResult } from "@tanstack/react-query";

import type { UUID } from "@/core/types";

import { getPatientFiles } from "../queryFunctions/getPatientFiles";
import type { PatientFile } from "../../types/PatientFile";
import { patientKeys } from "../keyFactory";

type UsePatientFilesProps<TData = PatientFile[]> = {
  patientId: UUID;
  select?: (data: PatientFile[]) => TData;
};

type PatientFilesQueryOptions = UseQueryOptions<
  PatientFile[],
  unknown,
  PatientFile[],
  ReturnType<typeof patientKeys.files>
>;

export function usePatientFiles<TData = PatientFile[]>({
  patientId,
  select,
}: UsePatientFilesProps<TData>): UseQueryResult<TData> {
  return useQuery({ ...optionFactory(patientId), select });
}

export function optionFactory(patientId: UUID) {
  return {
    queryFn: () => getPatientFiles(patientId),
    queryKey: patientKeys.files(patientId),
  } satisfies PatientFilesQueryOptions;
}
